import { Box } from "@mui/material";
import HomeSlider from "./HomeSlider";
import { useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";
import SliderCategory from "./SliderCategoryNew";
import ProductList from "./ProductList";
import SaleDeals from "./SaleDealsNew";
import { memo, useEffect } from "react";

const MainPage = () => {
  const {
    isLoading,
    storePage,
    categories,
    categories_without_arrange,
  } = useSelector((state) => state.store);
  const { language } = useSelector((state) => state.global);




  return (
    <>
      {isLoading ? (
        <CircularProgress className="full-preloader-position" />
      ) : (
        <Box>
          {storePage?.slider && (
            <Box>
              <HomeSlider sliders={storePage?.slider} />
            </Box>
          )}
          <Box sx={{ backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1a1a1a' : '#f8f9fa', padding: 0 }} >

            {storePage?.productOrderByPrice.length > 0 && (
              <SaleDeals productDeals={storePage?.productOrderByPrice} />
            )}

            {categories && (
              <Box className="slider-category">
                <SliderCategory categories={categories} language={language} />
              </Box>
            )}

          </Box>

          <Box>
            {storePage?.productNewArrivers.length > 0 && (
              <ProductList
                title="store.last_products"
                products={storePage?.productNewArrivers}
                list_of_catg={categories_without_arrange}
                language={language}
              />
            )}

            {storePage?.productReview.length > 0 && (
              <ProductList
                title="store.best_rated"
                products={storePage?.productReview}
                list_of_catg={categories_without_arrange}
                language={language}
              />
            )}
          </Box>
        </Box>

      )}
    </>
  );
}

export default memo(MainPage);


